import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import quarkusApi from '../../../api/quarkusApi';

export function useAnamnesisCatalog() {
  const navigate = useNavigate();

  const [questions, setQuestions] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchQuestions = useCallback(() => {
    setLoading(true);
    quarkusApi
      .get('/anamnesis-catalog', { headers: { Authorization: sessionStorage.getItem('token') } })
      .then((returnFromApi) => setQuestions(returnFromApi.data))
      .catch((returnFromApi) => {
        setError(returnFromApi.response?.data);
        console.error('ops! ocorreu um erro' + returnFromApi);
        if (returnFromApi.status === 401) {
          navigate('/expired-session');
        }
      })
      .finally(() => setLoading(false));
  }, [navigate]);

  useEffect(() => {
    fetchQuestions();
  }, [fetchQuestions]);

  return { questions, isLoading, error, refetch: fetchQuestions };
}
